// Global scripts from WP
import Modal from "./modules/Modal";
import PriceEstimationForm from "./modules/PriceEstimationForm";
import Animations from "./modules/Animations";
import LazyImages from "./modules/LazyImages";
import Cookies from "./modules/Cookies";
import { GetBrochure } from "./modules/GetBrochure";
import Header from "./modules/Header";
import Slider from "./modules/components/Slider";
// declare global window localize_script
window.localize_script = localize_script;
// Remove no-js class
document.querySelector('html').classList.remove('no-js');
new Modal();
new PriceEstimationForm();
new Animations();
new LazyImages();
new Cookies();
new GetBrochure();
new Header();
// Init slider components
const sliderComponents = document.querySelectorAll('.slider-default');
sliderComponents.forEach((component) => {
    new Slider(component);
});
